import {Header} from '../util/header';
import {Parallax} from '../util/parallax'
import {Accordeon} from '../util/accordeon'
import {ProductGrid} from '../util/productGrid'
import {Modal} from '../util/modal'
import AOS from "aos";


export default {
  init() {
    new Header()
    new Parallax()
    new Accordeon()
    new ProductGrid()
    new Modal()
    AOS.init();
    AOS.refresh();
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./js/routes/common.js